import { module } from 'modujs';
import { $html } from '../utils/dom';

export default class extends module {
    constructor(m) {
        super(m);
    }    

    onInview(e) {
        $html.classList.toggle('has-media-hero-inview', e.way == 'enter');
    }

    destroy() {
        super.destroy()

        $html.classList.remove('has-media-hero-inview')
    }
}
